export function getUser(state) {
  const { user } = state;
  return user;
}

export function getStaff(state) {
  const { staff } = state;
  return staff;
}

export function getCompany(state) {
  const { company } = state;
  return company;
}

export function getConversationsList(state) {
  const { chat: { conversationsList } } = state;
  return conversationsList;
}

export function getSelectedConversationFromStore(state) {
  const { chat: { conversation } } = state;
  return conversation;
}

export function getChat(state) {
  const { chat } = state;
  return chat;
}



// WEBPACK FOOTER //
// ./src/services/sagaUtils.js